module.exports = __webpack_public_path__ + "doc.png?176106ec22e4ee875f2f80c21c075cc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/doc.png
// module id = 52
// module chunks = 0